var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOthers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4393 1.5C13.9457 1.5 14.1718 1.60487 14.2836 1.71668C14.3954 1.82848 14.5003 2.05458 14.5003 2.561V5.389C14.5003 5.89542 14.3954 6.12152 14.2836 6.23332C14.1718 6.34513 13.9457 6.45 13.4393 6.45H10.6113C10.1049 6.45 9.87878 6.34513 9.76697 6.23332C9.65517 6.12152 9.55029 5.89542 9.55029 5.389V2.561C9.55029 2.05458 9.65517 1.82848 9.76697 1.71668C9.87878 1.60487 10.1049 1.5 10.6113 1.5H13.4393Z",
    stroke: "var(--color-1)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.39263 6.44301V6.443H5.38949H2.56149C2.04224 6.443 1.8066 6.34711 1.69498 6.24833C1.5991 6.16346 1.50049 5.99069 1.50049 5.557V2.386C1.50049 1.95685 1.59861 1.78293 1.69571 1.69665C1.80789 1.59698 2.04402 1.5 2.56149 1.5H5.38949C5.90696 1.5 6.14308 1.59698 6.25526 1.69665C6.35236 1.78293 6.45049 1.95685 6.45049 2.386V5.564C6.45049 5.99352 6.3522 6.16668 6.25599 6.25183C6.1449 6.35014 5.90982 6.44626 5.39263 6.44301Z",
    stroke: "var(--color-1)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.38949 9.55005C5.89591 9.55005 6.12201 9.65492 6.23381 9.76673C6.34561 9.87853 6.45049 10.1046 6.45049 10.611V13.439C6.45049 13.9455 6.34561 14.1716 6.23381 14.2834C6.12201 14.3952 5.89591 14.5 5.38949 14.5H2.56149C2.05507 14.5 1.82897 14.3952 1.71717 14.2834C1.60536 14.1716 1.50049 13.9455 1.50049 13.439V10.611C1.50049 10.1046 1.60536 9.87853 1.71717 9.76673C1.82897 9.65492 2.05507 9.55005 2.56149 9.55005H5.38949Z",
    stroke: "var(--color-1)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1001 10.45H14.3001",
    stroke: "var(--color-1)",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1001 13.25H14.3001",
    stroke: "var(--color-1)",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOthers);
export default __webpack_public_path__ + "static/media/OTHERS.50f919f716d6c44d14b92edc15b05586.svg";
export { ForwardRef as ReactComponent };